<template>
  <div style="color:#333;width: 800px;height: 500px;">
    <video id="video" width="640" height="480" autoplay></video>
  </div>
</template>
<script>

export default {
  name: 'view',
  data: function () {
    return {
    }
  },
  created: function () {
  },

  mounted: function () {
    console.log('出现');
    // 获取视频标签元素
    const video = document.getElementById('video');

    // 检查浏览器是否支持 getUserMedia API
    if (navigator.mediaDevices.getUserMedia) {
      // 设置媒体类型和尺寸
      const constraints = {
        video: {
          width: 640,
          height: 480
        }
      };

      // 获取用户媒体设备，例如摄像头
      navigator.mediaDevices.getUserMedia(constraints)
        .then(function (stream) {
          // 将视频流绑定到video元素上
          video.srcObject = stream;
        })
        .catch(function (err) {
          console.error('出错了：' + err);
        });
    } else {
      alert('不幸的是，你的浏览器不支持getUserMedia');
    }
  },

  methods: {
    // loadCkplayer() {
    //   let that = this;
    //   that.playerOptions.url = 'https://vod.couragetech.cn:8081/slcp/common/01.mp4';
    //   // that.playerOptions.poster = data.VideoCover;
    //   that.playerOptions.startTime = 0;
    //   that.progress = 0; // 当前进度
    //   that.seekingTime = 0; // 正在跳转的时间
    //   that.isSeep = false; // 是否允许跳转
    //   that.playerOptions.progress.closeMoveSeek = false;

    //   that.player = new SimplePlayer(that.playerOptions);
    //   // that.player.emit('resourceReady', [{ name: '超清', url: '//sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-720p.mp4' }, { name: '高清', url: '//sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-480p.mp4' }, { name: '标清', url: '//sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-360p.mp4' }]);

    //   that.player.on(Events.PlAY, () => {
    //     console.log('开始播放')
    //   })

    //   that.player.on(Events.SEEKING, (t) => {

    //   })

    //   // 监听错误
    //   that.player.on(Events.ERROR, (error) => {
    //     that.$alert('对不起，视频播放失败。请确认网络正常，在网络正常的情况下尝试关闭浏览器并重新打开。如果问题依然存在，请通过电话或其他方式联系我校工作人员。', '提示', {
    //       confirmButtonText: '确定'
    //     });
    //     console.log('player err', error)
    //   });

    //   that.player.on(Events.CANPLAY, (t) => {
    //     console.log('视频缓冲足够数据，可以播放', t);
    //     setTimeout(() => {
    //           that.player.play();
    //         }, 5000);
    //     });
    // }
  }
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/test.vue